export default function careerAnimation(timeline) {
  timeline
    .set(".hidden-wrapper > hr.animate-elem", { xPercent: -200 })
    .set(".hidden-wrapper > h2.animate-elem", { yPercent: 100 })
    .set(".advances-grid", { yPercent: 20, opacity: 0 })
    .to(".hidden-wrapper > hr.animate-elem", { xPercent: 0 })
    .to(".hidden-wrapper > h2.animate-elem", { yPercent: 0 })
    .to(".advances-grid", { yPercent: 0, opacity: 1 });
}
